// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1JlA5","title":"Info_title__2n8Te","selects":"Info_selects__3q37K","requiredAsterisk":"Info_requiredAsterisk__2JiCS"};